import { render, staticRenderFns } from "./ImportPortfolioDialog.vue?vue&type=template&id=81d978ee&scoped=true&"
import script from "./ImportPortfolioDialog.vue?vue&type=script&lang=js&"
export * from "./ImportPortfolioDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImportPortfolioDialog.vue?vue&type=style&index=0&id=81d978ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d978ee",
  null
  
)

export default component.exports